const multiplyMixBlendMode: { mixBlendMode: 'multiply' } = {
	mixBlendMode: 'multiply',
};

export const Laptop = ({ title }: { title: string }) => (
	<svg width="100%" viewBox="0 0 503 503" fill="none" xmlns="http://www.w3.org/2000/svg" role="img">
		<title>{title}</title>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M382.282 458C432.025 419.106 464 358.537 464 290.5C464 173.139 368.861 78 251.5 78C134.139 78 39 173.139 39 290.5C39 358.537 70.975 419.106 120.718 458H382.282Z"
			fill="#FECDCF"
		/>
		<path
			d="M445.536 435.811C430.031 430.57 407.473 427.496 375.722 438.026C370.375 439.799 367.94 445.866 370.261 451H464C463.527 447.857 459.171 440.42 445.536 435.811Z"
			fill="white"
		/>
		<rect x="369" y="451" width="95" height="7" fill="#B2BCC2" />
		<rect x="39" y="211" width="330" height="236" rx="14" fill="#3B4044" />
		<rect x="39" y="211" width="330" height="236" rx="14" stroke="#B2BCC2" />
		<path
			opacity="0.8"
			d="M0 445.4C0 452.359 5.64121 458 12.6 458H395.4C402.359 458 408 452.359 408 445.4C408 442.418 405.582 440 402.6 440H5.39999C2.41765 440 0 442.418 0 445.4Z"
			fill="#DBE1E6"
		/>
		<path d="M169 440C169 443.866 172.134 447 176 447H231C234.866 447 238 443.866 238 440H169Z" fill="#6D787E" />
		<rect x="56.1006" y="228.922" width="295.698" height="195.184" rx="2" fill="#ADCEFF" />
		<g style={multiplyMixBlendMode}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M56 374.236C63.7504 392.315 73.9365 409.102 86.1455 424.184H349.698C350.802 424.184 351.698 423.288 351.698 422.184V231C351.698 229.895 350.802 229 349.698 229H58C56.8954 229 56 229.895 56 231V374.236Z"
				fill="#ECF4FD"
			/>
		</g>
		<g style={multiplyMixBlendMode}>
			<circle cx="163.628" cy="323.592" r="5.84383" fill="#586165" />
			<circle cx="244.272" cy="323.592" r="5.84383" fill="#586165" />
		</g>
		<path
			opacity="0.3"
			d="M226.975 352.643C226.975 365.46 216.585 362.375 203.768 362.375C190.951 362.375 180.561 365.46 180.561 352.643C180.561 339.826 190.951 329.436 203.768 329.436C216.585 329.436 226.975 339.826 226.975 352.643Z"
			fill="white"
		/>
		<g style={multiplyMixBlendMode}>
			<path
				d="M226.975 352.643C226.975 365.46 216.585 362.375 203.768 362.375C190.951 362.375 180.561 365.46 180.561 352.643C180.561 339.826 190.951 329.436 203.768 329.436C216.585 329.436 226.975 339.826 226.975 352.643Z"
				fill="#FB5B63"
			/>
			<path
				d="M366 308.886C366 323.308 354.136 335 339.5 335C324.864 335 313 323.308 313 308.886C313 289.386 339.5 265 339.5 265C339.5 265 366 289.386 366 308.886Z"
				fill="#6BA6FF"
			/>
		</g>
	</svg>
);
